import React,{useEffect, useState} from 'react';
import { useAappContext } from '../context/AppContext';
import {Product,ProductDescription} from '../components/Product';
import SideNavNewsEvents from '../components/SideNavNewsEvents';
import '../PageCss/SingaleProductPage.css';
import '../PageCss/NewsEvent.css';
import ploader from '../assest/loading/Settings.gif';
import ProductS from "../components/ProductS";
import { useParams } from 'react-router-dom';

const API_SLUG = '/product/';
const SingleProduct = () => {
    const Ploader =ploader;
    const {getSingleProduct, singelProductLoading, singleProduct, products,reload,Pid} = useAappContext();
    const [currentPage, setCurrentPage] = useState(1);
    const productsPerPage = 9; // You can change this number
    const {product_id} = useParams();
    useEffect(() => {
      getSingleProduct(`${API_SLUG}${product_id}`)
    },[])
    
    useEffect(() => {
      setCurrentPage(1);
      getSingleProduct(`${API_SLUG}${Pid}`)
      window.scrollTo(0, 0);
    }, [reload])
    

    const [pcategory,setpcategory] = useState();
    const [pscategory,setpscategory] = useState();
    useEffect(() => {
      if (singleProduct.length > 0) {
        setpcategory(singleProduct[0].product_Category);
        setpscategory(singleProduct[0].product_Subcategory);
      }
    }, [singleProduct]);

    // Filter related products
  const relatedProducts = products.filter((curElem) => {
    return (
      curElem.product_Category === pcategory &&
      curElem.product_Subcategory === pscategory &&
      curElem.id !== Pid
    );
  });
// Pagination logic

const indexOfLastProduct = currentPage * productsPerPage;
const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
const currentProducts = relatedProducts.slice(indexOfFirstProduct, indexOfLastProduct);
const totalPages = Math.ceil(relatedProducts.length / productsPerPage);


    if(singelProductLoading) {
      return <div style={{
        minHeight:400,
        display:'flex',
        justifyContent:"center",
        alignItems:"center",
        fontSize:18,
        color:"#28a745"
      }}> <img src={Ploader} alt="page-loading" /> </div>
  }


    return (
  <>
       <section id="newevent" className='section-m1 section-p1'>
        <div className="newevent">
          <div id='page-title' className="title-yellow">
           <span>product</span>
          </div>
          <div className="newevent-content">
            <div id="product-continer" className='UTM_Aptima'>
            <div className="product">
              {
                singleProduct.map((product)=>{
                  return (<Product key={product.id} {...product} />);

                })
              }
            </div>
            <div id='page-title' className="title-red">
           <span>Product description</span>
          </div>

              <div className="discription" id='product-description'>
                {
                  singleProduct.map((descrip)=>{
                    return (
                    <ProductDescription key={descrip.id} {...descrip} />
                    )
                  })
                }
              </div>
            </div>
          
          </div>
          <div id='page-title' className="title-yellow">
           <span>Related Product</span>
          </div>

          <section id="productsSection">
  <div className="container" style={{flexWrap:'wrap'}}>
    <div className="productContaner" style={{ margin: 0 }}>
      {currentProducts.map((curElem) => (
        <ProductS key={curElem.id} {...curElem} />
      ))}
    </div>

   {/* Pagination Controls */}
   <div className="pagination-controls">
          <button onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1}>
            Prev
          </button>
          {[...Array(totalPages)].map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentPage(index + 1)}
              className={currentPage === index + 1 ? 'active' : ''}
            >
              {index + 1}
            </button>
          ))}
          <button onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages}>
            Next
          </button>
        </div>
   
  </div>
  
</section>


        </div>
       
        <SideNavNewsEvents/>
     
      
    </section>
    

  </> 

)}

export default SingleProduct